import { UrlWithTooltip } from 'components/ui'

const RefererCell = (props: any) => {
  const { renderedCellValue } = props
  return <UrlWithTooltip url={renderedCellValue} />
}

export default RefererCell
